var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1114(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 77,
    viewBox: "0 0 60 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_240_6114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 15H22.5V20H45V15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 25.0005H22.5V30.0005H45V25.0005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 35.0011H22.5V40.0011H45V35.0011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 45H22.5V50H45V45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 55.0005H22.5V60.0005H45V55.0005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15H12.5V20H17.5V15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 25.0005H12.5V30.0005H17.5V25.0005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 35.0011H12.5V40.0011H17.5V35.0011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 45H12.5V50H17.5V45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 55.0005H12.5V60.0005H17.5V55.0005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 0H5C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5V75C0 76.3261 0.526784 77.5979 1.46447 78.5355C2.40215 79.4732 3.67392 80 5 80H55C56.3261 80 57.5979 79.4732 58.5355 78.5355C59.4732 77.5979 60 76.3261 60 75V5C60 3.67392 59.4732 2.40215 58.5355 1.46447C57.5979 0.526784 56.3261 0 55 0ZM55 75H5V5H55V75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_240_6114",
    x: 0,
    y: 0,
    width: 60,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_240_6114"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1114);
export default __webpack_public_path__ + "static/media/Group 1114.ef703ef5838cdeb8dd9e91fb3c1d13e5.svg";
export { ForwardRef as ReactComponent };